"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionTitle = exports.getSessionInstructor = exports.getSessionImage = void 0;
const getSessionImage = (session) => {
    var _a, _b;
    return ((_a = session === null || session === void 0 ? void 0 : session.program) === null || _a === void 0 ? void 0 : _a.imageUrl) || ((_b = session === null || session === void 0 ? void 0 : session.instructor) === null || _b === void 0 ? void 0 : _b.imageUrl);
};
exports.getSessionImage = getSessionImage;
const getSessionInstructor = (session) => {
    var _a;
    return ((_a = session === null || session === void 0 ? void 0 : session.program) === null || _a === void 0 ? void 0 : _a.instructor) || (session === null || session === void 0 ? void 0 : session.instructor);
};
exports.getSessionInstructor = getSessionInstructor;
const getSessionTitle = (session) => {
    var _a;
    return ((_a = session === null || session === void 0 ? void 0 : session.program) === null || _a === void 0 ? void 0 : _a.title) || (session === null || session === void 0 ? void 0 : session.title);
};
exports.getSessionTitle = getSessionTitle;
//# sourceMappingURL=session-utils.js.map